export enum SemiConfiguratorValues {
  'InternalServerError' = 'We are sorry! We are experiencing some technical difficulties in fulfilling your request. Please try again in some time!',
}

export enum SemiConfigPropertyValues {
  MaximumItemsAllowed = 500,
}
